import { ASSISTANT_FAILURES } from '@/consts/assistant'

// 401 is absent on purpose: the axios interceptor reloads the page on it.
const readFailure = (error) => {
    if (!error?.response) {
        return { type: ASSISTANT_FAILURES.NETWORK }
    }

    const { status, data } = error.response

    switch (status) {
        case 403:
            return { type: ASSISTANT_FAILURES.FORBIDDEN }

        case 404:
            // "Not found", never "no access": someone else's conversation
            // answers 404 deliberately, because transcripts carry client names.
            return { type: ASSISTANT_FAILURES.NOT_FOUND }

        case 422:
            // The backend words the `audio` message to be shown verbatim.
            return {
                type: ASSISTANT_FAILURES.VALIDATION,
                message: data?.message,
                fields: data?.errors || {},
            }

        case 503:
            // `reason` is the only thing separating a silent gateway, which is
            // worth retrying, from a feature an administrator switched off.
            return data?.reason
                ? { type: ASSISTANT_FAILURES.GATEWAY_DOWN }
                : { type: ASSISTANT_FAILURES.SWITCHED_OFF }

        default:
            return { type: ASSISTANT_FAILURES.UNKNOWN }
    }
}

export default readFailure
